import { Medal } from "lucide-react";
import Panel from "./Panel";
import { cn } from "../../../utils/tailwindUtils";

const METRICS = [
    { key: "won", label: "Deals won", unit: "" },
    { key: "activities", label: "Activities logged", unit: "" },
    { key: "conversion_rate", label: "Conversion", unit: "%" },
    { key: "show_rate", label: "Demo show rate", unit: "%" },
];

// Two bars per metric: me, and the average rep. Never another rep's name.
const Compare = ({ label, me, avg, unit }) => {
    const max = Math.max(Number(me) || 0, Number(avg) || 0, 1);
    const fmt = (v) => (v === null || v === undefined ? "—" : `${v}${unit}`);
    const better = me !== null && avg !== null && me !== undefined && avg !== undefined && Number(me) >= Number(avg);
    return (
        <div>
            <div className="flex items-baseline justify-between">
                <p className="text-xs text-gray-600 dark:text-gray-300">{label}</p>
                <p className={cn("text-xs font-semibold tabular-nums",
                    better ? "text-emerald-600 dark:text-emerald-400" : "text-gray-800 dark:text-gray-100")}>
                    {fmt(me)} <span className="font-normal text-gray-400">vs {fmt(avg)}</span>
                </p>
            </div>
            <div className="mt-1 space-y-0.5">
                <div className="h-1.5 rounded-full bg-gray-100 dark:bg-gray-700">
                    <div className="h-1.5 rounded-full bg-brand-600" style={{ width: `${(100 * (Number(me) || 0)) / max}%` }} />
                </div>
                <div className="h-1.5 rounded-full bg-gray-100 dark:bg-gray-700">
                    <div className="h-1.5 rounded-full bg-gray-300 dark:bg-gray-500" style={{ width: `${(100 * (Number(avg) || 0)) / max}%` }} />
                </div>
            </div>
        </div>
    );
};

const MeVsTeam = ({ data, loading }) => {
    const d = data || {};
    return (
        <Panel title="Me vs team" icon={Medal} loading={loading}
               badge={d.reps > 1 && (
                   <span className="text-[11px] font-semibold px-1.5 py-0.5 rounded-full bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-200">
                       #{d.rank} of {d.reps}
                   </span>
               )}>
            <div className="space-y-3">
                {METRICS.map(m => (
                    <Compare key={m.key} label={m.label} unit={m.unit}
                             me={d.me?.[m.key]} avg={d.team_avg?.[m.key]} />
                ))}
            </div>
            <p className="flex items-center gap-3 text-[11px] text-gray-400 mt-3">
                <span className="flex items-center gap-1"><span className="w-2 h-2 rounded-full bg-brand-600" /> You</span>
                <span className="flex items-center gap-1"><span className="w-2 h-2 rounded-full bg-gray-300 dark:bg-gray-500" /> Team average</span>
                <span className="ml-auto">this month</span>
            </p>
        </Panel>
    );
};

export default MeVsTeam;
